import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'

/**
 * True when the account has an organisation whose registration is not active. Used to gate
 * flows that submit to the backend on behalf of the organisation (Native Apply, Smart Apply):
 * such submissions fail for organisations that are not registration-active.
 */
export function useIsOrganisationInactive(): boolean {
  const {
    authState: { organisation }
  } = useAuthState()

  return !!organisation && !organisation.registrationActive
}
